import { isCompanyEmail } from 'free-email-domains-list';
import { Step } from './components/steps/Step';
import {
    companySize,
    contentTypeCustomerSuccess,
    contentTypeCustomerSupport,
    contentTypeEducation,
    contentTypeFreelancerContentCreator,
    contentTypeHR,
    contentTypeInnovationDepartment,
    contentTypeLearningAndDevelopmentDepartment,
    contentTypeMarketingDepartment,
    contentTypePersonal,
    contentTypeProductManagement,
    contentTypeRnDDepartment,
    contentTypeSales,
    hearAboutUs,
    industry,
    marketing,
    roleStep,
    seniority,
    targetAudienceBusiness,
    targetAudiencePersonal,
} from './steps';
import { OnboardingClass, OnboardingFlows } from './steps/common';

const personalFlow: Step[] = [contentTypePersonal, marketing, targetAudiencePersonal, hearAboutUs];

const businessFlow: Step[] = [
    seniority,
    contentTypeMarketingDepartment,
    contentTypeLearningAndDevelopmentDepartment,
    contentTypeSales,
    contentTypeHR,
    contentTypeCustomerSupport,
    contentTypeProductManagement,
    contentTypeFreelancerContentCreator,
    contentTypeCustomerSuccess,
    contentTypeEducation,
    contentTypeInnovationDepartment,
    contentTypeRnDDepartment,
    roleStep,
    companySize,
    targetAudienceBusiness,
    // newWebsiteBusiness,
    industry,
    hearAboutUs,
];

const onboardingClassToFlow = {
    [OnboardingClass.Personal]: personalFlow,
    [OnboardingClass.Work]: businessFlow,
};

export const getFlow = (
    onboardingType: OnboardingClass,
    state: {
        [OnboardingFlows.Class]: OnboardingClass;
        [key: string]: any;
    },
    email?: string
) => {
    const finalOnboardingType = email && isCompanyEmail(email.toLowerCase()) ? OnboardingClass.Work : onboardingType;

    const selectedFlow = onboardingClassToFlow[finalOnboardingType];
    if (!selectedFlow) return [];
    return selectedFlow.reduce((steps, step) => {
        if (!step.showCondition) {
            return [...steps, step];
        } else {
            const conditionStep = selectedFlow.find(flowStep => flowStep.id === step.showCondition?.stepId);
            if (!conditionStep || state[conditionStep.id] === step.showCondition.selectedOption) {
                return [...steps, step];
            } else {
                return steps;
            }
        }
    }, [] as Step[]);
};
